import $ from 'jquery';
import 'slick-carousel';

const reviewsCarousel = () => {
	const el = {
		target: '.mi-carousel__reviews',
		loop_container: '.elementor-loop-container',
		loop_nav: '.mi-carousel__reviews__nav',
	};

	let $target = $();

	const init = () => {
		$(function () {
			if (!$(el.target).length) return;

			$target = $(el.target).find(el.loop_container);
			exec();
		});
	};

	const exec = () => {
		$target.find('style').prependTo($target.parent());

		$target.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			arrows: true,
			appendArrows: $(el.loop_nav),
			waitForAnimate: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 601,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});
	};

	init();
};

try {
	reviewsCarousel();
} catch (error) {
	console.error(error);
}
